import React, { useState } from "react";
import PropTypes from "prop-types";
import { ChevronDown, ChevronRight } from "lucide-react";

const Accordion = ({ title, children, defaultOpen = true, className = "", HeadingclassName = "" }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`w-full ${className}`}>
      <button
        className="w-full flex items-center justify-start py-2 text-left focus:outline-none group"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`text-sm font-bold text-[#000000] ${HeadingclassName}`}>{title}</span>
        {isOpen ? (
          <ChevronDown className="w-4 h-4 text-gray-700 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
        ) : (
          <ChevronRight className="w-4 h-4 text-gray-700 group-hover:text-gray-700 mb-1" />
        )}
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-[5000px] opacity-100" : "max-h-0 opacity-0"
          }`}
      >
        <div className="pb-2">{children}</div>
      </div>
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool,
  className: PropTypes.string,
};

export default Accordion;
